import SeoLandingLayout from './components/SeoLandingLayout';

export default function NutricionDeportivaPage() {
  return (
    <SeoLandingLayout
      title="Nutricion Deportiva en Palma de Mallorca | Dario Rojas"
      description="Servicio de nutricion deportiva en Palma de Mallorca con Dario Rojas. Mejora rendimiento, recuperacion y composicion corporal."
      canonicalPath="/nutricion-deportiva-palma-de-mallorca"
      heading="Nutricion deportiva en Palma de Mallorca"
      intro="Diseño estrategias de nutricion deportiva para entrenamiento, competicion y recuperacion. Cada plan se adapta a tu disciplina, horarios y nivel."
      bullets={[
        'Plan nutricional para mejorar rendimiento deportivo',
        'Estrategia de pre y post entrenamiento',
        'Soporte para ganancia muscular o definicion',
        'Ajustes segun carga de entrenamiento y competiciones',
      ]}
      sections={[
        {
          title: 'Nutricion deportiva adaptada a tu disciplina',
          paragraphs: [
            'La nutricion deportiva no es igual para todos. Ajusto el plan segun el tipo de deporte, intensidad de entrenamientos, calendario competitivo y objetivos fisicos.',
            'Trabajamos energia disponible, recuperacion, hidratacion y timing de nutrientes para mejorar rendimiento sin complicar tu rutina.',
          ],
        },
        {
          title: 'Mejor rendimiento y recuperacion',
          paragraphs: [
            'Un buen plan reduce fatiga, mejora adaptaciones al entrenamiento y ayuda a prevenir bajones de energia durante sesiones largas.',
            'Si entrenas en Palma y buscas una estrategia nutricional profesional, te acompaño con seguimiento continuo y ajustes por fases.',
          ],
        },
      ]}
      faqItems={[
        {
          question: 'La nutricion deportiva sirve si no compito?',
          answer:
            'Si. Tambien es util para quienes entrenan por salud, rendimiento personal o mejora de composicion corporal.',
        },
        {
          question: 'Se adapta el plan si cambio de rutina de entrenamiento?',
          answer:
            'Si. El plan se ajusta en funcion del volumen, intensidad y objetivos de cada etapa.',
        },
        {
          question: 'Incluyes estrategia para antes y despues del entreno?',
          answer:
            'Si. Definimos nutricion pre y post entrenamiento para optimizar energia y recuperacion.',
        },
      ]}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Nutricion deportiva en Palma de Mallorca',
        provider: {
          '@type': 'Person',
          name: 'Dario Rojas',
          jobTitle: 'Nutricionista y Dietista',
        },
        areaServed: 'Palma de Mallorca',
        serviceType: 'Nutricion deportiva',
        url: 'https://dariorojasnutricion.es/nutricion-deportiva-palma-de-mallorca',
      }}
    />
  );
}
